<div class="n-oldalfej">
  <div>
    <h2>Évi paraméterek</h2>
    <span class="n-alcim">Az új évre az előző év értékei öröklődnek; itt felülírhatók</span>
  </div>
  <div class="spacer"></div>
  <label class="ev-valaszto">Év
    <select [ngModel]="ev" (ngModelChange)="evValt(+$event)"><option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option></select>
  </label>
  <ion-button (click)="ment()" [disabled]="mentes || !be"><ion-icon slot="start" name="save-outline"></ion-icon>Mentés</ion-button>
</div>

<div class="ber-param" *ngIf="be">
  <div class="n-panel">
    <div class="n-panel-cim">Bérek és kulcsok – {{ ev }}</div>
    <label class="kv-mezo"><span>Minimálbér (Ft/hó)</span><input type="number" [(ngModel)]="be.minimalber"></label>
    <label class="kv-mezo"><span>Garantált bérminimum</span><input type="number" [(ngModel)]="be.garantalt_berminimum"></label>
    <label class="kv-mezo"><span>SZJA kulcs (%)</span><input type="number" [(ngModel)]="be.szja_kulcs"></label>
    <label class="kv-mezo"><span>TB-járulék (%)</span><input type="number" [(ngModel)]="be.tb_kulcs"></label>
    <label class="kv-mezo"><span>Szocho (%)</span><input type="number" [(ngModel)]="be.szocho_kulcs"></label>
    <label class="kv-mezo" title="A 25/30 év alattiak kedvezményének felső korlátja"><span>Átlagkereset (Ft/hó)</span><input type="number" [(ngModel)]="be.atlagkereset"></label>
    <label class="kv-mezo"><span>Letiltható hányad (%)</span><input type="number" [(ngModel)]="be.letiltas_max_szazalek"></label>
    <label class="kv-mezo" title="Vht. 62–63. §: ennyi mentes a levonás alól, és az ÖTSZÖRÖSE feletti bér korlátlanul levonható. 2027. január 1-jétől 120 000 Ft.">
      <span>Nyugdíjminimum (Ft/hó)</span><input type="number" [(ngModel)]="be.nyugdijminimum"></label>
    <label class="kv-mezo" title="Szja tv. 25. § (2) b): a munkába járás km-térítése eddig a mértékig nem jövedelem (2026-ban 30 Ft/km); a fölötte lévő rész bérként adózik.">
      <span>Munkába járás (Ft/km, adómentes)</span><input type="number" [(ngModel)]="be.km_terites_adomentes"></label>
  </div>
  <div class="n-panel">
    <div class="n-panel-cim">Kedvezmények (adóalap / hó)</div>
    <label class="kv-mezo"><span>Családi – 1 eltartott</span><input type="number" [(ngModel)]="be.csaladi_1"></label>
    <label class="kv-mezo"><span>Családi – 2 (/fő)</span><input type="number" [(ngModel)]="be.csaladi_2"></label>
    <label class="kv-mezo"><span>Családi – 3+ (/fő)</span><input type="number" [(ngModel)]="be.csaladi_3"></label>
    <label class="kv-mezo"><span>Első házasok</span><input type="number" [(ngModel)]="be.elsohazas"></label>
    <label class="kv-mezo"><span>Személyi kedvezmény</span><input type="number" [(ngModel)]="be.szemelyi"></label>
  </div>
</div>
